import React from 'react';

import { isEmpty } from '@utils/common';
import { getTaskXCoordinate } from '@components/common/Gantt/helpers/barHelper';

import { Task } from '@interfaces/ganttTasks/ganttTasks';

import colors from '@constants/colors';
import { MIN_GANTT_HEIGHT } from '@components/common/Gantt/constants';

import styles from './CurrentDateIndicator.module.scss';

interface ICurrentDateIndicatorProps {
	dates: Date[];
	columnWidth: number;
	rowHeight: number;
	tasks: Task[];
}

const CurrentDateIndicator = ({
	dates,
	columnWidth,
	tasks,
	rowHeight,
}: ICurrentDateIndicatorProps) => {
	const xCoordinate = getTaskXCoordinate(new Date(), dates, columnWidth);

	const y1Coordinate = 3;
	const y2Coordinate = !isEmpty(tasks) ? tasks.length * rowHeight : MIN_GANTT_HEIGHT;

	return (
		<g>
			<line
				className={styles.currentDateIndicatorLine}
				x1={xCoordinate}
				x2={xCoordinate}
				y1={y1Coordinate}
				y2={y2Coordinate}
			/>
			<circle
				cx={xCoordinate}
				cy={y1Coordinate}
				fill={colors.indigo60}
				r={y1Coordinate}
			/>
		</g>
	);
};

export default CurrentDateIndicator;
